import router from './router'
import store from './store'

//const whiteList = ['/'] // no redirect whitelist
//const isDev = process.env.NODE_ENV === 'development' ? true : true;
router.beforeEach(async (to, from, next) => {
  store.dispatch('user/getInfo').then(res => {
    // this.$message('登录成功')
  }).catch(err => {
    // store.dispatch('user/logout')
    console.log('err',err)
  })
  store.commit('app/SET_MENUS', to)
  if(to.path.includes('government')){
    document.title = '政策惠企';
  }
  // let  urlName = to.meta.title?to.meta.title:to.matched.length>0?to.matched[0].meta.title:'';
  // let  preUrl = from.meta.title?from.meta.title:from.matched.length>0?from.matched[0].meta.title:'';
  // window.sessionStorage.setItem("url",urlName.replace(/\s+/g,''))      //当前页面 pg
  // window.sessionStorage.setItem("preUrl",preUrl.replace(/\s+/g,''))    //上一个页面 prepg
  next()
})
// window.addEventListener("message", (event)=>{
//   // 通常，onmessage()事件处理程序应当首先检测其中的origin属性，忽略来自未知源的消息
//   // console.log('origin',event)
//   // console.log('userInfo====',store.getters.userInfo)
//   if (!isDev && event.data.status=='login'){
//     store.dispatch('user/getInfo').then(res => {
//       if(Object.keys(store.getters.userInfo).length==0){
//         window.location.href = process.env.NODE_ENV === 'testing'?"http://cs-www.hbgyl.com.cn/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href):"http://www.hbgyl.com.cn/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href)
//       }else if( Object.keys(store.getters.userInfo).length>0 && event.data.username != store.getters.userInfo.preferred_username){
//         window.location.href = process.env.NODE_ENV === 'testing'?"http://cs-www.hbgyl.com.cn/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href):"http://www.hbgyl.com.cn/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href)
//       }  
//     }).catch(() =>{
//       window.location.href = process.env.NODE_ENV === 'testing'?"http://cs-www.hbgyl.com.cn/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href):"http://www.hbgyl.com.cn/dmdp-homepage/sync/Front/frontRedirect.do?frontRedirectUrl=" + encodeURIComponent(window.location.href)
//     })
//   }else if(!isDev && event.data.status=='logout'){
//     store.dispatch('user/logout')
//   }
// }, false);



// WEBPACK FOOTER //
// ./src/permission.js